module.exports = __webpack_public_path__ + "img/93ne.0098248f.svg";